// Module
var code = `<survey-modal platforms="vm.platforms" survey-manager="vm.surveyManager" ng-if="vm.showUpdateMobileNumberSurvey" current-mobile-number="vm.currentMobileNumber" participant-id="participantId"></survey-modal>`;
// Exports
export default code;